import { Shield, Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import PublicShell from '@/components/layouts/PublicShell';

const AltersvorsorgeePage = () => {
  return (
    <PublicShell>
          {/* Hero Section - Exact Height */}
          <div className="relative" style={{height: '70vh'}}>
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-handshake.jpg)'}}
            ></div>
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-800/60 to-transparent"></div>
            
            <div className="relative z-10 h-full flex items-center px-16">
              <div className="max-w-3xl">
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight font-serif">
              Altersvorsorge
            </h1>
                
                <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 max-w-3xl">
                  Für finanzielle Sicherheit im Ruhestand - Ihre private Altersvorsorge
                </p>
                
          </div>
        </div>
      </div>

          {/* Green Section */}
          <div className="bg-primary-800">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Shield className="w-16 h-16 text-white" />
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight font-serif">
                    Warum private <em className="italic">Altersvorsorge?</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Die gesetzliche Rente allein reicht oft nicht aus. Mit unserer privaten Altersvorsorge sichern Sie Ihren Lebensstandard. 
                    Je früher Sie beginnen, desto mehr profitieren Sie vom Zinseszinseffekt.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-group-meeting.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Three White Cards Section - Benefits */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                  {/* Card 1 - Versorgungslücke */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Versorgungslücke schließen</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Berechnen und schließen Sie die Lücke zwischen gesetzlicher Rente und Ihrem gewünschten Lebensstandard. 
                      Wir analysieren Ihre aktuelle Situation und zeigen Ihnen konkrete Lösungswege auf.
                  </p>
                </div>

                  {/* Card 2 - Früh anfangen */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Früh anfangen lohnt sich</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Je früher Sie beginnen, desto mehr profitieren Sie vom Zinseszinseffekt und können entspannter vorsorgen. 
                      Schon kleine Beträge können über Jahre hinweg zu einem beachtlichen Vermögen anwachsen.
                    </p>
                  </div>

                  {/* Card 3 - Steuerliche Vorteile */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Steuerliche Vorteile</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Nutzen Sie staatliche Förderungen und steuerliche Vorteile für Ihre private Altersvorsorge. 
                      Riester-Rente, Rürup-Rente und betriebliche Altersvorsorge bieten verschiedene Steuervorteile.
                    </p>
                  </div>
                </div>
              </div>
            </div>
                      </div>

          {/* Purple Section - Products */}
          <div className="bg-primary-900 py-20">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Star className="w-16 h-16 text-white" />
                  </div>

                  <h2 className="text-4xl md:text-5xl font-light text-gold-400 mb-8 leading-tight font-serif">
                    Unsere <em className="italic">Altersvorsorge-Produkte</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Von der staatlich geförderten Riester-Rente bis zur flexiblen privaten Rentenversicherung - 
                    wir haben das passende Produkt für Ihre Vorsorgestrategie.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-skyline-evening.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Three White Cards Section - Products */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                  {/* Card 1 - Riester-Rente */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Riester-Rente</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Staatlich geförderte Altersvorsorge mit Zulagen und Steuervorteilen.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Staatliche Grundzulage: 175€ pro Jahr</div>
                      <div>• Kinderzulage: bis zu 300€ pro Kind</div>
                      <div>• Steuerliche Absetzbarkeit</div>
                      <div>• Garantierte Rente im Alter</div>
                        </div>
                      </div>

                  {/* Card 2 - Rürup-Rente */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Rürup-Rente</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Ideal für Selbstständige und Gutverdiener mit hohen Steuervorteilen.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Bis zu 25.787€ steuerlich absetzbar</div>
                      <div>• Besonders für Selbstständige geeignet</div>
                      <div>• Flexible Beitragszahlungen</div>
                      <div>• Lebenslange Rente garantiert</div>
                    </div>
                </div>

                  {/* Card 3 - Private Rentenversicherung */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Private Rentenversicherung</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Flexible private Vorsorge ohne staatliche Vorgaben.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Maximale Flexibilität</div>
                      <div>• Kapitalwahlrecht</div>
                      <div>• Verschiedene Anlagestrategien</div>
                      <div>• Hinterbliebenenabsicherung möglich</div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>

          {/* CTA Section - Green */}
          <div className="bg-primary-800 py-16">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  Starten Sie jetzt mit Ihrer Altersvorsorge
                </h2>
                <p className="text-xl text-primary-100 mb-8 leading-relaxed">
                  Lassen Sie uns gemeinsam die optimale Altersvorsorge-Strategie für Sie entwickeln. 
                  Je früher Sie anfangen, desto besser.
                </p>
              <Link to="/contact">
                  <Button className="bg-white text-primary-700 hover:bg-gray-100 px-8 py-4 text-lg font-medium rounded-none shadow-lg border border-gray-200">
                    <span className="text-primary-700 font-bold">Kostenlose Beratung vereinbaren</span>
                    <ArrowRight className="ml-2 w-5 h-5 text-primary-700" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
    </PublicShell>
  );
};

export default AltersvorsorgeePage;
